// Shared date-range presets for the H&S export and H&S history pages — extracted so
// both pick from the exact same 3 ranges instead of duplicating the date math.

// Local calendar date, not UTC — .toISOString() converts to UTC first, which rolls a
// local-midnight Date back a day in any timezone ahead of UTC (e.g. a local-midnight
// Aug 1 becomes "2026-07-31" once shifted to UTC). Presets built from local midnight
// (thisMonthRange, lastMonthRange) need this; last7DaysRange happens not to hit
// midnight so the bug was invisible there.
export function toISODate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function thisMonthRange() {
  const now = new Date();
  return [toISODate(new Date(now.getFullYear(), now.getMonth(), 1)), toISODate(now)];
}

export function lastMonthRange() {
  const now = new Date();
  return [toISODate(new Date(now.getFullYear(), now.getMonth() - 1, 1)), toISODate(new Date(now.getFullYear(), now.getMonth(), 0))];
}

export function last7DaysRange() {
  const now = new Date();
  const from = new Date(now);
  from.setDate(from.getDate() - 6);
  return [toISODate(from), toISODate(now)];
}

export function todayRange() {
  const now = new Date();
  return [toISODate(now), toISODate(now)];
}

export function last30DaysRange() {
  const now = new Date();
  const from = new Date(now);
  from.setDate(from.getDate() - 29);
  return [toISODate(from), toISODate(now)];
}

export function last31DaysRange() {
  const now = new Date();
  const from = new Date(now);
  from.setDate(from.getDate() - 30);
  return [toISODate(from), toISODate(now)];
}

// "Last 31 days" first and default, matching hs-history.html's own active chip and its
// seeded 31-day window. Distinct from last30DaysRange, which the DateRangePill uses.
export const PRESETS = [
  { label: "Last 31 days", range: last31DaysRange },
  { label: "This month", range: thisMonthRange },
  { label: "Last month", range: lastMonthRange },
  { label: "Last 7 days", range: last7DaysRange },
];

// The shared .neura-date-control popover's own preset set (assets/neura.css +
// neura.js), used by the DateRangePill. Deliberately a superset of PRESETS above,
// which stays exactly as-is because hs-history.html and hs-export.html hand-roll
// their own 3-chip row rather than using the shared control.
// "Last 24h" from the shared list is omitted — these are date-only ranges, so it
// would be indistinguishable from Today.
export const RANGE_PRESETS = [
  { key: "today", label: "Today", range: todayRange },
  { key: "last-7-days", label: "Last 7 days", range: last7DaysRange },
  { key: "last-30-days", label: "Last 30 days", range: last30DaysRange },
  { key: "this-month", label: "This month", range: thisMonthRange },
  { key: "last-month", label: "Last month", range: lastMonthRange },
];
